/**
 * SectionCard — белая карточка секции внутри вкладок карточки клиента:
 * заголовок, необязательное пояснение и действие справа.
 */

import type {ReactNode} from 'react';

type Props = {
  title: string;
  hint?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
};

export const SectionCard = ({title, hint, action, children}: Props) => (
  <div className="rounded-[13px] border border-skr-line bg-card px-[18px] py-4">
    <div className="mb-3 flex items-start justify-between gap-3">
      <div>
        <div className="text-sm font-semibold">{title}</div>
        {hint && (
          <div className="mt-0.5 text-[12px] leading-[1.45] text-muted-foreground">{hint}</div>
        )}
      </div>
      {action}
    </div>
    {children}
  </div>
);
